/* ==========================================================================
   Apoywood klonu — katalog motoru.
   Gerçek Shopify ürünü yok; katalog assets/catalog-*.json içinde duruyor.
   Ürün ve koleksiyon görünümleri anasayfa üzerinde ?c= / ?p= parametreleriyle
   açılıyor, gezinme History API ile yapılıyor.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-oaky-root]');
  if (!root) return;

  var SRC = {
    index: root.dataset.index,
    detail: root.dataset.detail,
    collections: root.dataset.collections,
    pages: root.dataset.pages,
  };

  var DB = { index: null, collections: null, detail: null, pages: null, byHandle: {}, byColl: {} };

  /* --- yardımcılar --------------------------------------------------------- */

  function money(n) {
    return '$' + Number(n).toFixed(2).replace(/\.00$/, '');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Renk adlarını yaklaşık swatch renklerine eşle. Eşleşmeyen değer gri gösterilir.
  var SWATCH = {
    oak: '#c99b62',
    walnut: '#6b4327',
    black: '#1a1a1a',
    white: '#f2f2f2',
    grey: '#9a9a9a',
    gray: '#9a9a9a',
    'light grey': '#c9c9c9',
    'dark grey': '#5c5c5c',
    graphite: '#3d3d3d',
    navy: '#2b3a55',
    green: '#4a6350',
    beige: '#d9c7a8',
    cream: '#ece3d2',
    sand: '#d6c3a5',
    burgundy: '#6d2233',
    silver: '#cfcfcf',
    natural: '#d3b48c',
  };

  function swatchColor(name) {
    var k = String(name).toLowerCase().trim();
    if (SWATCH[k]) return SWATCH[k];
    for (var key in SWATCH) if (k.indexOf(key) !== -1) return SWATCH[key];
    return '#d2d2d2';
  }

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(url + ' -> ' + r.status);
      return r.json();
    });
  }

  /* --- ürün kartı ---------------------------------------------------------- */

  // Rozetler tag yerine koleksiyon üyeliğinden geliyor. Tag'lerde "new" araması
  // "renewable" gibi alakasız etiketlere de takılıyordu.
  var BEST = {};
  var NEW = {};

  function buildBadgeSets() {
    (DB.byColl['bestsellers'] ? DB.byColl['bestsellers'].p : []).forEach(function (h) { BEST[h] = 1; });
    (DB.byColl['new-arrivals'] ? DB.byColl['new-arrivals'].p : []).forEach(function (h) { NEW[h] = 1; });
  }

  function card(p) {
    var badge = '';
    if (p.c && p.c > p.p) {
      badge = '<span class="oaky-badge oaky-badge--sale">Sale</span>';
    } else if (BEST[p.h]) {
      badge = '<span class="oaky-badge">Best Seller</span>';
    } else if (NEW[p.h]) {
      badge = '<span class="oaky-badge">New</span>';
    }

    var alt = p.im[1] ? '<img class="oaky-card__alt" src="' + esc(p.im[1]) + '" alt="" loading="lazy">' : '';

    var price = p.pmax > p.p ? 'From ' + money(p.p) : money(p.p);
    var compare = p.c && p.c > p.p ? '<s>' + money(p.c) + '</s>' : '';

    var sw = (p.sw || [])
      .map(function (v) {
        return '<span class="oaky-sw" style="background:' + swatchColor(v) + '" title="' + esc(v) + '"></span>';
      })
      .join('');

    return (
      '<a class="oaky-card" href="?p=' + encodeURIComponent(p.h) + '" data-oaky-link>' +
      '<div class="oaky-card__media">' + badge +
      '<img src="' + esc(p.im[0] || '') + '" alt="' + esc(p.t) + '" loading="lazy">' + alt +
      '</div>' +
      '<div class="oaky-card__body">' +
      '<div class="oaky-card__title">' + esc(p.t) + '</div>' +
      '<div class="oaky-card__price">' + price + compare + '</div>' +
      (sw ? '<div class="oaky-card__swatches">' + sw + '</div>' : '') +
      '</div></a>'
    );
  }

  /* --- anasayfa ızgaraları ------------------------------------------------- */

  function productsOf(handle) {
    var c = DB.byColl[handle];
    if (!c) return [];
    return c.p.map(function (h) { return DB.byHandle[h]; }).filter(Boolean);
  }

  function fillGrids(scope) {
    (scope || document).querySelectorAll('[data-oaky-grid]').forEach(function (el) {
      var list = el.dataset.collection ? productsOf(el.dataset.collection) : DB.index.slice();
      if (el.dataset.sort === 'new') list = list.slice().reverse();
      var limit = parseInt(el.dataset.limit || '0', 10);
      if (limit > 0) list = list.slice(0, limit);
      el.innerHTML = list.length
        ? list.map(card).join('')
        : '<p class="oaky-empty">No products in this collection.</p>';
    });
  }

  /* --- koleksiyon görünümü ------------------------------------------------- */

  function renderCollection(handle, sort) {
    var c = DB.byColl[handle];
    var view = document.querySelector('[data-oaky-view]');
    if (!c) {
      view.innerHTML = '<div class="oaky-wrap oaky-empty"><h2 class="oaky-h-md">Collection not found</h2></div>';
      return;
    }
    var items = productsOf(handle);
    if (sort === 'price-asc') items = items.slice().sort(function (a, b) { return a.p - b.p; });
    if (sort === 'price-desc') items = items.slice().sort(function (a, b) { return b.p - a.p; });
    if (sort === 'name') items = items.slice().sort(function (a, b) { return a.t.localeCompare(b.t); });

    // Koleksiyonun kendi görseli yoksa ilk ürünün görseline düş
    var hero = c.im || (items[0] && items[0].im[0]) || '';

    view.innerHTML =
      '<section class="oaky-collhero"><div class="oaky-collhero__in">' +
      '<div><h1 class="oaky-h-lg">' + esc(c.t) + '</h1>' +
      (c.d ? '<p>' + esc(c.d) + '</p>' : '') + '</div>' +
      (hero ? '<img src="' + esc(hero) + '" alt="' + esc(c.t) + '">' : '<div></div>') +
      '</div></section>' +
      '<div class="oaky-wrap">' +
      '<div class="oaky-toolbar">' +
      '<span class="oaky-count">' + items.length + (items.length === 1 ? ' product' : ' products') + '</span>' +
      '<select class="oaky-select" data-oaky-sort>' +
      '<option value="">Featured</option>' +
      '<option value="price-asc"' + (sort === 'price-asc' ? ' selected' : '') + '>Price: low to high</option>' +
      '<option value="price-desc"' + (sort === 'price-desc' ? ' selected' : '') + '>Price: high to low</option>' +
      '<option value="name"' + (sort === 'name' ? ' selected' : '') + '>Alphabetical</option>' +
      '</select></div>' +
      '<div class="oaky-grid">' + items.map(card).join('') + '</div>' +
      '<div style="height:70px"></div></div>';

    var sel = view.querySelector('[data-oaky-sort]');
    if (sel) {
      sel.addEventListener('change', function () {
        renderCollection(handle, sel.value);
      });
    }
  }

  /* --- ürün görünümü ------------------------------------------------------- */

  function renderProduct(handle) {
    var view = document.querySelector('[data-oaky-view]');
    ensureDetail().then(function () {
      var d = DB.detail[handle];
      var idx = DB.byHandle[handle];
      if (!d) {
        view.innerHTML = '<div class="oaky-wrap oaky-empty"><h2 class="oaky-h-md">Product not found</h2></div>';
        return;
      }

      // Başlangıç seçimi ilk VARYANTTAN türetiliyor. Opsiyon listesinin ilk
      // değerlerini almak bazı ürünlerde var olmayan bir kombinasyon üretiyordu
      // (varyant başlıkları eksik parçalı gelebiliyor).
      var picked = d.op.map(function (o) { return o.v[0]; });
      if (d.va.length) {
        var firstParts = String(d.va[0].t).split(' / ');
        if (firstParts.length === d.op.length) picked = firstParts;
      }

      function currentVariant() {
        var key = picked.join(' / ');
        var exact = d.va.find(function (v) { return v.t === key; });
        if (exact) return exact;
        // Tam eşleşme yoksa en çok opsiyonu tutan varyantı seç
        var best = d.va[0];
        var bestScore = -1;
        d.va.forEach(function (v) {
          var parts = String(v.t).split(' / ');
          var score = 0;
          picked.forEach(function (val, i) { if (parts[i] === val) score++; });
          if (score > bestScore) { bestScore = score; best = v; }
        });
        return best;
      }

      function optionsHTML() {
        return d.op
          .map(function (o, i) {
            return (
              '<div class="oaky-optgroup"><div class="oaky-optgroup__label">' + esc(o.n) + '</div>' +
              '<div class="oaky-optvals">' +
              o.v
                .map(function (val) {
                  return (
                    '<button type="button" class="oaky-optval" data-opt="' + i + '" data-val="' + esc(val) + '"' +
                    ' aria-pressed="' + (picked[i] === val) + '">' + esc(val) + '</button>'
                  );
                })
                .join('') +
              '</div></div>'
            );
          })
          .join('');
      }

      function priceHTML() {
        var v = currentVariant();
        return money(v.p) + (v.c && v.c > v.p ? '<s>' + money(v.c) + '</s>' : '');
      }

      function paint() {
        view.querySelector('[data-oaky-price]').innerHTML = priceHTML();
        view.querySelectorAll('.oaky-optval').forEach(function (b) {
          b.setAttribute('aria-pressed', picked[b.dataset.opt] === b.dataset.val);
        });
        var v = currentVariant();
        var sku = view.querySelector('[data-oaky-sku]');
        if (sku) sku.textContent = v.s ? 'SKU ' + v.s : '';
        if (v.i) {
          var main = view.querySelector('.oaky-pdp__gallery img');
          if (main) main.src = v.i;
        }
      }

      var gallery = d.im.slice(0, 7)
        .map(function (src) { return '<img src="' + esc(src) + '" alt="' + esc(d.t) + '" loading="lazy">'; })
        .join('');

      view.innerHTML =
        '<div class="oaky-wrap"><nav class="oaky-crumb">' +
        '<a href="?" data-oaky-link>Home</a> / ' + esc(d.t) + '</nav>' +
        '<div class="oaky-pdp">' +
        '<div class="oaky-pdp__gallery">' + gallery + '</div>' +
        '<div class="oaky-pdp__info">' +
        '<h1 class="oaky-h-md">' + esc(d.t) + '</h1>' +
        '<div class="oaky-pdp__price" data-oaky-price>' + priceHTML() + '</div>' +
        (d.ty ? '<div class="oaky-count">' + esc(d.ty) + '</div>' : '') +
        optionsHTML() +
        '<button type="button" class="oaky-btn oaky-btn--dark oaky-pdp__cta" data-oaky-demo-cta>Add to cart</button>' +
        '<div class="oaky-pdp__meta"><span data-oaky-sku></span>' +
        '<span>' + d.va.length + ' variants</span><span>30-day returns</span>' +
        '<span>5-year warranty</span></div>' +
        (d.d ? '<div class="oaky-pdp__desc">' + d.d + '</div>' : '') +
        '</div></div>';

      view.querySelectorAll('.oaky-optval').forEach(function (b) {
        b.addEventListener('click', function () {
          picked[b.dataset.opt] = b.dataset.val;
          paint();
        });
      });
      var cta = view.querySelector('[data-oaky-demo-cta]');
      if (cta) {
        cta.addEventListener('click', function () {
          cta.textContent = 'Demo store - checkout is not enabled';
          setTimeout(function () { cta.textContent = 'Add to cart'; }, 2200);
        });
      }
      paint();

      // İlgili ürünler: önce aynı ürün tipi, o boşsa ürünün bulunduğu en küçük
      // (dolayısıyla en spesifik) koleksiyondan komşular. 26 üründe product_type
      // boş olduğu için tek başına tipe bakmak yetmiyor.
      var related = idx
        ? DB.index.filter(function (p) { return p.ty && p.ty === idx.ty && p.h !== handle; })
        : [];
      if (related.length < 4) {
        var owning = DB.collections
          .filter(function (c) { return c.p.indexOf(handle) !== -1; })
          .sort(function (a, b) { return a.p.length - b.p.length; })[0];
        if (owning) {
          var seen = {};
          related.concat([]).forEach(function (p) { seen[p.h] = 1; });
          owning.p.forEach(function (h) {
            if (h !== handle && !seen[h] && DB.byHandle[h] && related.length < 4) {
              seen[h] = 1;
              related.push(DB.byHandle[h]);
            }
          });
        }
      }
      related = related.slice(0, 4);
      if (related.length) {
        var wrap = document.createElement('div');
        wrap.className = 'oaky-wrap oaky-sec--tight';
        wrap.innerHTML =
          '<div class="oaky-sec__head"><h2 class="oaky-h-md">Related products</h2></div>' +
          '<div class="oaky-grid">' + related.map(card).join('') + '</div>';
        view.appendChild(wrap);
      }
    });
  }

  var detailPromise = null;
  function ensureDetail() {
    if (DB.detail) return Promise.resolve();
    if (!detailPromise) {
      detailPromise = fetchJSON(SRC.detail).then(function (d) { DB.detail = d; });
    }
    return detailPromise;
  }

  var pagesPromise = null;
  function ensurePages() {
    if (DB.pages) return Promise.resolve();
    if (!pagesPromise) {
      pagesPromise = fetchJSON(SRC.pages).then(function (d) { DB.pages = d; });
    }
    return pagesPromise;
  }

  /* --- içerik sayfaları ---------------------------------------------------- */

  // Doldurulmamış bölümler uydurulmuyor; neden boş olduğu açıkça yazılıyor.
  function emptyBlock(note) {
    return (
      '<div class="oaky-blank">' +
      '<span class="oaky-blank__tag">Pending</span>' +
      '<p>' + esc(note || 'This section has not been filled in yet.') + '</p>' +
      '</div>'
    );
  }

  function articleHTML(p) {
    var out = '';
    if (p.hero) out += '<img class="oaky-page__hero" src="' + esc(p.hero) + '" alt="' + esc(p.title) + '">';
    if (p.lead) out += '<p class="oaky-page__lead">' + esc(p.lead) + '</p>';
    if (p.empty) return out + emptyBlock(p.note);

    (p.blocks || []).forEach(function (b, i) {
      out +=
        '<section class="oaky-page__row' + (b.img && i % 2 ? ' oaky-page__row--flip' : '') + '">' +
        '<div><h2 class="oaky-h-md">' + esc(b.h) + '</h2><p>' + esc(b.p) + '</p></div>' +
        (b.img ? '<img src="' + esc(b.img) + '" alt="' + esc(b.h) + '" loading="lazy">' : '') +
        '</section>';
    });

    if (p.cards && p.cards.length) {
      out +=
        '<div class="oaky-sec__head" style="margin-top:40px"><h2 class="oaky-h-md">Collaboration opportunities</h2></div>' +
        '<div class="oaky-brand__grid">' +
        p.cards
          .map(function (c) {
            return (
              '<a class="oaky-brand__card" href="?page=' + encodeURIComponent(c.page) + '" data-oaky-link>' +
              '<div><h3>' + esc(c.t) + '</h3><p>' + esc(c.d) + '</p></div></a>'
            );
          })
          .join('') +
        '</div>';
    }
    return out;
  }

  function faqHTML(p) {
    var out = p.lead ? '<p class="oaky-page__lead">' + esc(p.lead) + '</p>' : '';
    (p.groups || []).forEach(function (g) {
      out += '<h2 class="oaky-faq__group">' + esc(g.h) + '</h2>';
      if (g.empty) {
        out += emptyBlock(g.note);
        return;
      }
      (g.items || []).forEach(function (it) {
        out +=
          '<details class="oaky-faq__item"><summary>' + esc(it.q) + '</summary>' +
          '<p>' + esc(it.a) + '</p></details>';
      });
    });
    return out;
  }

  function contactHTML(p) {
    var out = p.lead ? '<p class="oaky-page__lead">' + esc(p.lead) + '</p>' : '';
    out +=
      '<div class="oaky-contact">' +
      '<form class="oaky-contact__form" data-oaky-demo-form>' +
      '<label>Name<input type="text" required></label>' +
      '<label>Email<input type="email" required></label>' +
      '<label>Message<textarea rows="6" required></textarea></label>' +
      '<button type="submit" class="oaky-btn oaky-btn--dark">Send</button>' +
      '<span class="oaky-contact__status" data-oaky-form-status></span>' +
      '</form><div class="oaky-contact__side">';
    (p.details || []).forEach(function (d) {
      // href verilmişse (telefon gibi) tıklanabilir yap
      var body = d.href
        ? '<a href="' + esc(d.href) + '">' + esc(d.p) + '</a>'
        : esc(d.p);
      out += '<div class="oaky-contact__item"><h3>' + esc(d.h) + '</h3><p>' + body + '</p></div>';
    });
    // E-posta ve telefon sonradan eklenecek; uydurmak yerine açıkça bekliyor gösteriliyor.
    if (p.extraEmpty) out += emptyBlock(p.extraNote);
    out += '</div></div>';
    return out;
  }

  function blogHTML(p) {
    var out = p.lead ? '<p class="oaky-page__lead">' + esc(p.lead) + '</p>' : '';
    if (p.empty) return out + emptyBlock(p.note);
    out +=
      '<div class="oaky-grid">' +
      (p.posts || [])
        .map(function (a) {
          return (
            '<article class="oaky-card"><div class="oaky-card__media">' +
            '<img src="' + esc(a.img) + '" alt="' + esc(a.t) + '" loading="lazy"></div>' +
            '<div class="oaky-card__body"><div class="oaky-card__title">' + esc(a.t) + '</div>' +
            '<p class="oaky-count">' + esc(a.d) + '</p></div></article>'
          );
        })
        .join('') +
      '</div>';
    return out;
  }

  function renderPage(slug) {
    var view = document.querySelector('[data-oaky-view]');
    ensurePages().then(function () {
      var p = DB.pages[slug];
      if (!p) {
        view.innerHTML =
          '<div class="oaky-wrap oaky-empty"><h2 class="oaky-h-md">Page not found</h2></div>';
        return;
      }
      var body =
        p.type === 'faq' ? faqHTML(p) : p.type === 'contact' ? contactHTML(p) : p.type === 'blog' ? blogHTML(p) : articleHTML(p);

      view.innerHTML =
        '<div class="oaky-wrap"><nav class="oaky-crumb"><a href="?" data-oaky-link>Home</a> / ' +
        esc(p.title) + '</nav>' +
        '<article class="oaky-page"><h1 class="oaky-h-lg">' + esc(p.title) + '</h1>' +
        body + '</article><div style="height:70px"></div></div>';

      var form = view.querySelector('[data-oaky-demo-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          form.querySelector('[data-oaky-form-status]').textContent =
            'Demo store - this message was not sent anywhere.';
        });
      }
    });
  }

  /* --- yönlendirme --------------------------------------------------------- */

  function route() {
    var q = new URLSearchParams(location.search);
    var p = q.get('p');
    var c = q.get('c');
    var pg = q.get('page');
    var home = document.querySelectorAll('[data-oaky-home]');
    var view = document.querySelector('[data-oaky-view]');

    if (p || c || pg) {
      home.forEach(function (el) { el.hidden = true; });
      view.hidden = false;
      if (p) renderProduct(p);
      else if (c) renderCollection(c, '');
      else renderPage(pg);
      // Horizon'da kaydırma .page-wrapper içinde; window.scrollTo işe yaramıyor
      var scroller = document.querySelector('.page-wrapper');
      if (scroller) scroller.scrollTo({ top: 0, behavior: 'instant' });
      window.scrollTo(0, 0);
    } else {
      home.forEach(function (el) { el.hidden = false; });
      view.hidden = true;
      view.innerHTML = '';
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-oaky-link]');
    if (!a) return;
    // yeni sekme / dış bağlantı davranışını bozma
    if (e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    e.preventDefault();
    history.pushState({}, '', a.getAttribute('href'));
    route();
  });

  window.addEventListener('popstate', route);

  /* --- menü ---------------------------------------------------------------- */

  function wireNav() {
    var nav = document.querySelector('.oaky-nav');
    if (!nav) return;
    document.querySelectorAll('[data-oaky-nav-open]').forEach(function (b) {
      b.addEventListener('click', function () { nav.setAttribute('open', ''); });
    });
    nav.addEventListener('click', function (e) {
      if (e.target === nav || e.target.closest('[data-oaky-nav-close]')) nav.removeAttribute('open');
    });
  }

  /* --- başlat -------------------------------------------------------------- */

  Promise.all([fetchJSON(SRC.index), fetchJSON(SRC.collections)])
    .then(function (res) {
      DB.index = res[0];
      DB.collections = res[1];
      DB.index.forEach(function (p) { DB.byHandle[p.h] = p; });
      DB.collections.forEach(function (c) { DB.byColl[c.h] = c; });
      buildBadgeSets();
      fillGrids();
      wireNav();
      route();
      root.setAttribute('data-oaky-ready', '');
    })
    .catch(function (err) {
      console.error('[oaky] catalog failed to load', err);
      document.querySelectorAll('[data-oaky-grid]').forEach(function (el) {
        el.innerHTML = '<p class="oaky-empty">Catalog failed to load.</p>';
      });
    });
})();
